import { formatDateTime } from 'utils/dates/date.utils';
import { displayValue, displayValueWithUnit } from 'utils/valueFormatting/display.utils';
import WeatherMapList, {
  WeatherMapListButton,
} from '../../../../../../components/WeatherMapList/WeatherMapList';
import { formatEarthquakeLocation } from '../../../../utils/earthquakes.utils';

const EarthquakeList = ({
  earthquakes = [],
  selectedEarthquakeId = null,
  isRefreshing = false,
  onSelectEarthquake,
}) => (
  <WeatherMapList
    title="Recent Earthquakes"
    countLabel={`${earthquakes.length} ${earthquakes.length === 1 ? 'event' : 'events'}`}
    isRefreshing={isRefreshing}
    className="earthquake-list flex-grow-1"
    listClassName="earthquake-list-items"
  >
    {earthquakes.map((earthquake) => {
      const isSelected = earthquake.id === selectedEarthquakeId;
      const location = formatEarthquakeLocation(earthquake.city);
      const secondaryTextClassName = isSelected ? 'text-white' : 'text-secondary';

      return (
        <li key={earthquake.id}>
          <WeatherMapListButton
            isSelected={isSelected}
            className="earthquake-list-button flex-column gap-1 p-3"
            aria-label={`View ${location}, magnitude ${displayValue(earthquake.magnitude)}`}
            onClick={() => onSelectEarthquake?.(earthquake)}
          >
            <span className="fw-bold text-break">{location}</span>
            <span className={`small ${secondaryTextClassName}`}>
              {formatDateTime(earthquake.occurrence)}
            </span>
            <span className="d-flex flex-wrap gap-2 small fw-semibold">
              <span>Magnitude {displayValue(earthquake.magnitude)}</span>
              <span aria-hidden="true">|</span>
              <span>Depth {displayValueWithUnit(earthquake.depth, ' km')}</span>
            </span>
          </WeatherMapListButton>
        </li>
      );
    })}
  </WeatherMapList>
);

export default EarthquakeList;
